import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { MonthRangeSelector } from "components/ui/MonthRangeSelector";

dayjs.locale("ko");

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 60px;
`;

export const MembersDashboardHeaderSection = () => {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();

  const endMonthParam =
    searchParams.get("endMonth") || dayjs().format("YYYY-MM");
  const endDate = dayjs(endMonthParam);

  const handleDateChange = (newEndDate: dayjs.Dayjs) => {
    updateUrlParams({ endMonth: newEndDate.format("YYYY-MM") });
  };

  return (
    <HeaderWrapper>
      <MonthRangeSelector endDate={endDate} onDateChange={handleDateChange} />
    </HeaderWrapper>
  );
};
